import { watchDebounced } from '@vueuse/core'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useApi } from '@/functions/api'
import { useSearchGlobalStore } from '@/stores/search-global'

export function useDashboard () {
  const api = useApi()
  const route = useRoute()
  const router = useRouter()

  const chartPeriod = computed({
    get: () => (route.query.selected_type as string) || '12_months',
    set: (value: string) => {
      router.push({
        query: {
          ...route.query,
          selected_type: value,
        },
      })
    },
  })

  const loading = ref(false)
  const data = ref<DashboardResponse>()

  const apiParams = computed(() => {
    return {
      type: chartPeriod.value,
    }
  })

  watch(chartPeriod, () => {
    getData()
  })

  const getData = async () => {
    loading.value = true
    try {
      const response = await api.GET<DashboardResponse>('admin/dashboard', apiParams.value)
      data.value = response
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    data,
    chartPeriod,
    getData,
  }
}

export function useDashboardSearch () {
  const searchGlobal = useSearchGlobalStore()
  const api = useApi()

  const getData = async () => {
    if (!searchGlobal.search) {
      return
    }
    searchGlobal.loading = true
    try {
      const response = await api.GET<SearchGlobal>('admin/search', {
        search: searchGlobal.search,
      })
      searchGlobal.members = response.members ?? []
      searchGlobal.products = response.products ?? []
      searchGlobal.categories = response.categories ?? []
      searchGlobal.promos = response.promos ?? []
      searchGlobal.vouchers = response.vouchers ?? []
      searchGlobal.orders = response.orders ?? []
    } finally {
      searchGlobal.loading = false
    }
  }

  watchDebounced(
    () => searchGlobal.search,
    () => {
      getData()
    },
    { debounce: 500 },
  )
}
